import { api } from "@/services/api"

export type EngagementExportQuery = {
  forMonthStartingOn: string
}

export const exportEngagementReport = async (
  query: EngagementExportQuery,
  format?: FileExportFormat
) => {
  const data = await api.get<Blob>(
    `/engagement/export/${buildQueryString({
      ...query,
      format,
    })}`
  )
  return exportFileFromRespone(data)
}
